import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const DonutChartIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13 5.08C16.06 5.52 18.48 7.94 18.92 11L21.95 11C21.48 6.28 17.72 2.52 13 2.05L13 5.08ZM18.92 13C18.48 16.06 16.06 18.48 13 18.92L13 21.95C17.72 21.48 21.48 17.72 21.95 13L18.92 13ZM11 18.92C7.61 18.43 5 15.52 5 12S7.61 5.57 11 5.08L11 2.05C5.95 2.55 2 6.81 2 12S5.95 21.45 11 21.95L11 18.92Z"
      fill="currentColor"
    />
  </svg>
);

DonutChartIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(DonutChartIcon);
